/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_EyebrowInputs */

const en_why_listening_compare_eyebrow = /** @type {(inputs: Why_Listening_Compare_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it compares`)
};

const es_why_listening_compare_eyebrow = /** @type {(inputs: Why_Listening_Compare_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo se compara`)
};

/**
* | output |
* | --- |
* | "How it compares" |
*
* @param {Why_Listening_Compare_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_eyebrow = /** @type {((inputs?: Why_Listening_Compare_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_eyebrow(inputs)
	return en_why_listening_compare_eyebrow(inputs)
});